import * as React from "react";
import styled from "styled-components";
import { MeetingStatusTxtMap } from "@/types";
import { AnyType } from "@/types";
import { Menu, message } from "antd";

const Container = styled.div`
  width: 100%;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
  transition: background-color 0.3s;
  padding: 5px 10px;
  &:hover {
    background-color: #eee;
  }
  .cname {
    color: #333;
    height: 25px;
    font-size: 14px;
    align-items: center;
    display: flex;
  }
  .cid {
    display: flex;
    color: #999;
    height: 25px;
    align-items: center;
    .ccid,
    .cstatus {
      flex: 1;
    }
  }
  .begin {
    display: flex;
    color: #999;
    height: 25px;
    align-items: center;
    justify-content: space-between;
    a {
      color: red;
    }
    .ml15 {
      margin-left: 15px;
    }
    .operation span {
      color: red;
      cursor: pointer;
    }
  }
`;

interface MeetItemProps {
  item: AnyType;
  onOperation?: (conferenceNo: string, operation: string) => void;
}

const MeetItem: React.FunctionComponent<MeetItemProps> = ({
  item,
  onOperation = () => {},
}) => {
  const { title, status = "", beginTime = "", conferenceNo = "" } = item;

  const viewMeeting = () => {
    onOperation(item.conferenceNo, "view");
  };
  const deleteMeeting = () => {
    onOperation(item.conferenceNo, "delete");
  };

  return (
    <Container>
      <div className="cname">
        <span>{title}</span>
      </div>
      <div className="cid">
        <div className="ccid">会议号: {conferenceNo}</div>
        {/* <div className="cstatus">{MeetingStatusTxtMap[status]}</div> */}
        <div className="cstatus"> 已结束</div>
      </div>
      <div className="begin">
        <div className="bbegin">{beginTime}</div>
        <div className="operation">
          <span onClick={viewMeeting}>查看</span>
          <span onClick={deleteMeeting} className="ml15">
            删除
          </span>
        </div>
      </div>
    </Container>
  );
};

export default MeetItem;
/**
 
agenda: ""
agendaId: "477846163400167424"
agendaPermission: 0
allMuteState: 0
allowEarlyEntry: 1
allowSelfUnmute: 1
beginTime: "2021-12-16 14:00:00"
conferenceNo: "1315005711"
createTime: "2021-12-16 13:35:36"
endTime: "2021-12-16 15:00:00"
enterTime: ""
exitTime: ""
id: 1
imTokenId: "1y82gbu1000cgghd8flj4rc610sr3fn7"
links: "http://www.suhangcloud.com/1315005711"
lockedState: 0
muteJoinMeeting: 1
ownerId: "qzxugatsjokkbnf"
ownerName: "闫华"
ownerPassword: ""
password: ""
passwordEnable: 0
playTips: 0
recordPermission: 0
roomId: "191836409873597798"
sharePermission: 0
status: 0
title: "闫华预约的会议"
tokenId: "1y82gbu1000cgghd8flj42m600qz3rdt"
type: 1
updateTime: "2021-12-16 13:35:36"
useSelfConference: 0


 */
